import { AiFillHtml5 } from 'react-icons/ai';
import { DiCss3, DiJavascript } from 'react-icons/di';
import { RiReactjsFill } from 'react-icons/ri';
import { FaBootstrap, FaNodeJs } from 'react-icons/fa';
import { SiChakraui, SiRedux, SiExpress, SiMongodb } from 'react-icons/si';
import './styles.css'
import skinstore from '../assets/projectsImg/skinstore.png';
import dotandkey from '../assets/projectsImg/dotandkey.png';
import tripvillas from '../assets/projectsImg/tripvillas.png';
import engagebay from '../assets/projectsImg/engagebay.png';
import clockify from '../assets/projectsImg/clockify.png';
import Tata1mg from '../assets/projectsImg/1mg.png';

const projects = [
    {
        id: 1,
        category: 'E-Commerce',
        image: Tata1mg,
        source: 'https://github.com/abdullahhassan19/rambunctious-attraction-3750',
        view: 'https://welness-pharma.vercel.app/',
        title: '1mg Clone',
        description: '1mg is an e-commerce website that provides all the pharma products at the best price.',
        tech: [[<AiFillHtml5 className="techIcon" />, "HTML5"], [<DiCss3 className="techIcon" />, "CSS3"], [<DiJavascript className="techIcon" />, "JavaScript"], [<RiReactjsFill className="techIcon" />, "React"], [<SiRedux className="techIcon" />, "Redux"], [<SiChakraui className="techIcon" />, "Chakra UI"], [<FaNodeJs className="techIcon" />, "NodeJs"], [<SiExpress className="techIcon" />, "ExpressJs"], [<SiMongodb className="techIcon" />, "MongoDB"]]
    },
    {
        id: 2,
        category: 'Productivity',
        image: clockify,
        source: 'https://github.com/RupeshSahu969/equable-pleasure-9638',
        view: 'https://equable-pleasure-9638-c48w3p921-rupeshsahu969.vercel.app/',
        title: 'Clockify Clone',
        description: 'Clockify is the most popular free time tracker and timesheet app for teams of all sizes. Unlike all the other time trackers, Clockify lets you have unlimited tips and products online.',
        tech: [[<AiFillHtml5 className="techIcon" />, "HTML5"], [<DiCss3 className="techIcon" />, "CSS3"], [<DiJavascript className="techIcon" />, "JavaScript"], [<RiReactjsFill className="techIcon" />, "React"], [<SiRedux className="techIcon" />, "Redux"], [<SiChakraui className="techIcon" />, "Chakra UI"],]
    },
    {
        id: 3,
        category: 'E-Commerce',
        image: skinstore,
        source: 'https://github.com/SouravDhawa/Group_project_skinstore_website',
        view: 'https://euphonious-marigold-38d635.netlify.app/',
        title: 'Skinstore Clone',
        description: 'SkinStore is an e-commerce cosmetic store web application that allows you to cosmetics products online.',
        tech: [[<AiFillHtml5 className="techIcon" />, "HTML5"], [<DiCss3 className="techIcon" />, "CSS3"], [<DiJavascript className="techIcon" />, "JavaScript"], [<FaBootstrap className="techIcon" />, "Bootstrap"]]
    },
    {
        id: 4,
        category: 'E-Commerce',
        image: dotandkey,
        source: 'https://github.com/ahsanofficial/dotandkey-clone',
        view: 'https://gilded-clafoutis-4bdad5.netlify.app/',
        title: 'Dot&key Clone',
        description: `Dot&key is an e-commerce cosmetic store web application that
        allows you to cosmetics products online.`,
        tech: [[<AiFillHtml5 className="techIcon" />, "HTML5"], [<DiCss3 className="techIcon" />, "CSS3"], [<DiJavascript className="techIcon" />, "JavaScript"], [<FaBootstrap className="techIcon" />, "Bootstrap"]]
    },
    {
        id: 5,
        category: 'Marketing',
        image: engagebay,
        source: 'https://github.com/ahsanofficial/engagebay-clone',
        view: 'https://engagebayclone.netlify.app/',
        title: 'Engagebay Clone',
        description: `EngageBay is world's #1 affordable all-in-one marketing, sales, and support CRM software supporting over 29500 growing companies around the world. EngageBay helps companies to acquire, engage, nurture web visitors and convert them to happy customers and grow their business 5x and more`,
        tech: [[<AiFillHtml5 className="techIcon" />, "HTML5"], [<DiCss3 className="techIcon" />, "CSS3"], [<DiJavascript className="techIcon" />, "JavaScript"], [<RiReactjsFill className="techIcon" />, "React"], [<SiChakraui className="techIcon" />, "Chakra UI "]]
    }, {
        id: 6,
        category: 'Vacation',
        image: tripvillas,
        source: 'https://github.com/ahsanofficial/tripvillas-clone',
        view: 'https://tripvillasclone.netlify.app/',
        title: 'Tripvillas Clone',
        description: `Tripvillas is one of Asia's largest Holiday Home Rental Companies. Browse your ideal vacation home from over 1350 holiday homes spread across 231 destinations.`,
        tech: [[<AiFillHtml5 className="techIcon" />, "HTML5"], [<DiCss3 className="techIcon" />, "CSS3"], [<DiJavascript className="techIcon" />, "JavaScript"], [<RiReactjsFill className="techIcon" />, "React"], [<SiChakraui className="techIcon" />, "Chakra UI "]]
    }
]

export default projects;